import { startCase } from 'lodash';
const removeExtension = (s) => s.replace(/\.\S*$/, '');
const trimConsequentSpaces = (s) => s.replace(/\s+/g, ' ');
const removeSpecialChars = (s) => s.replace(/[^a-zA-Z0-9]/g, ' ');
const lowercaseAllButFirst = (s) => {
    const [first, ...rest] = s.split(' ');
    return [first, ...rest.map((w) => w.toLowerCase())].join(' ');
};
const toAltText = (s) => {
    const reducers = [
        decodeURIComponent,
        removeExtension,
        removeSpecialChars,
        trimConsequentSpaces,
        startCase,
        lowercaseAllButFirst,
    ];
    return reducers.reduce((acc, fn) => fn(acc), s);
};
export { toAltText };
//# sourceMappingURL=toAltText.js.map